import { render, staticRenderFns } from "./EmailConfirmationBanner.vue?vue&type=template&id=7199f670&scoped=true"
import script from "./EmailConfirmationBanner.vue?vue&type=script&lang=ts"
export * from "./EmailConfirmationBanner.vue?vue&type=script&lang=ts"
import style0 from "./EmailConfirmationBanner.vue?vue&type=style&index=0&id=7199f670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7199f670",
  null
  
)

export default component.exports